import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from '../../common/breadcrumb';
import FormularioBanner from './formulario_banners';
import Button from 'react-bootstrap-button-loader';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import Dropzone from "react-dropzone-uploader";
import { DEFAULT_BANNER_TYPE, getBannerTypeLabel, getBannerRecommendedSize } from '../../../constant/bannerTypes';
import { LEVEL_ONE_ORDER_OPTIONS, checkBannerOrderAvailability, isLevelOneBanner } from '../../../utils/bannerOrder';

const SITE_BASE_URL = ( 'https://lprefacciones.mx' /*  'http://localhost:5000' */).replace(/\/+$/, '');
const DEFAULT_BANNER_IMAGE = `${SITE_BASE_URL}/img/default-image.png`;
const buildBannerImageUrl = (value, fallbackId) => {
    if(!value) return '';
    const str = String(value).trim();
    if(!str) return '';
    if(/^https?:\/\//i.test(str)) return str;
    return `${SITE_BASE_URL}/${str.replace(/^\/+/, '')}`;
};
const buildRemoteSliderUrl = (id) => id ? `${SITE_BASE_URL}/images/slider/${id}.png` : '';

const Banners = (props) => {

    const [datos, setDatos] = useState({ nombre: '', sucursal: 0, img: '', img_url: '', es_ruta: false, ruta: '', ruta_valida: false, estatus: true, tipo_banner: DEFAULT_BANNER_TYPE, orden_banner: LEVEL_ONE_ORDER_OPTIONS[0] });
    const [look, setLook] = useState(false);
    const [modal2, setModal2] = useState();
    const [ID, setID] = useState(props.pag_actualizar);
    const [archivo, setFiles] = useState([]);
    const [orderModal, setOrderModal] = useState({ open: false, order: null, occupantName: '', payload: null, isUpdate: false });
    const toggle2 = () => setModal2(!modal2)

    useEffect(() => {
        if(ID != 0){
            fetch('/p_banners', {method : 'PATCH', body: JSON.stringify({ID}), headers: {'Content-Type': 'application/json'}})
            .then(res => res.json())
            .then(res => { 
                console.log(res);
                let data = res[0]
                const resolvedOrder = Number(data?.ORDEN_BANNER ?? data?.orden_banner);
                const normalizedOrder = Number.isFinite(resolvedOrder) && resolvedOrder > 0
                    ? resolvedOrder
                    : LEVEL_ONE_ORDER_OPTIONS[0];
                const imagePath = data.IMG_BANNER || ''
                const sliderUrl = buildRemoteSliderUrl(ID)
                const resolvedImageUrl = imagePath ? buildBannerImageUrl(imagePath) : sliderUrl
                setDatos({ nombre: data.NOMBRE_BANNER, sucursal: data.ID_SUCURSAL_BANNER, img: imagePath, img_url: resolvedImageUrl || sliderUrl, es_ruta: data.ES_RUTA_BANNER, ruta: data.ES_RUTA_BANNER ? data.RUTA_BANNER : '', ruta_valida: data.ES_RUTA_BANNER, estatus: data.ESTATUS_BANNER, tipo_banner: data.TIPO_BANNER || DEFAULT_BANNER_TYPE, orden_banner: normalizedOrder })
            })
            .catch(err => { console.log('Error: ' + err) })
        }
        
    }, []);

    const releasePreviewUrl = (value) => {
        if (value && typeof value === 'string' && value.startsWith('blob:')) {
            URL.revokeObjectURL(value);
        }
    };

    useEffect(() => {
        return () => {
            releasePreviewUrl(datos.img_url);
        };
    }, [datos.img_url]);

    const changeDropzone = ({ meta, file }, status) => {
        //console.log('Meta',meta, 'File',file,'Todos los archivos',allFiles.length);
        if (status == 'rejected_file_type') {
            //alerta('warning','Archivo no permitido',2)
            toast.warn('Archivo no permitido', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        if (status === 'done') {
            document.querySelector('.dzu-dropzone').classList.remove('error')
            const previewUrl = URL.createObjectURL(file);
            setFiles([{ id: meta.id, file }]);
            setDatos(prev => {
                releasePreviewUrl(prev.img_url);
                return { ...prev, img: meta.name, img_url: previewUrl };
            });

            toast.success('Archivo adjuntado', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        if (status === 'removed') {
            setFiles([]);
            setDatos(prev => {
                releasePreviewUrl(prev.img_url);
                return { ...prev, img:'', img_url:'' };
            });
            //console.log('removed')
        }
        if (status == 'error_file_size') {

            toast.warn('El archivo debe ser inferior a 10 MB', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }


    const recommendedSize = getBannerRecommendedSize(datos.tipo_banner);
    const recommendedLabel = getBannerTypeLabel(datos.tipo_banner);

    const handleBannerSubmit = async (isUpdate = false) => {
        const { nombre, sucursal, img, es_ruta, ruta_valida } = datos
        const requiresOrderSelection = isLevelOneBanner(datos.tipo_banner)
        const hasOrder = requiresOrderSelection ? Boolean(datos.orden_banner) : true
        const hasArchivo = isUpdate ? ((img && img.length) || (datos.img_url && datos.img_url.length) ? true : archivo.length != 0) : archivo.length != 0

        if(nombre != '' && sucursal != 0 && datos.tipo_banner && hasArchivo && ( es_ruta ? ruta_valida : true) && hasOrder){
            const normalizedOrder = requiresOrderSelection ? Number(datos.orden_banner) : 1
            const payload = { ...datos, orden_banner: normalizedOrder }
            try {
                const orderCheckPayload = {
                    tipo_banner: payload.tipo_banner,
                    orden_banner: payload.orden_banner
                }
                if (isUpdate && ID) {
                    orderCheckPayload.id = ID
                    orderCheckPayload.ID = ID
                }
                const orderCheck = await checkBannerOrderAvailability(orderCheckPayload)
                if (orderCheck.hasConflict) {
                    setOrderModal({
                        open: true,
                        order: payload.orden_banner,
                        occupantName: orderCheck.occupantName,
                        payload,
                        isUpdate
                    })
                    return
                }
                await persistBanner({ payload, isUpdate, forceReplace: false })
            } catch (error) {
                console.error('No se pudo validar el orden del banner:', error)
                toast.error('No se pudo validar el orden del banner. Intenta de nuevo.')
            }
        }
        else{
            var mensaje_texto = <div>Tienes campos vac??os 
                { nombre == '' && (<div><br/>-Debes introducir un nombre</div>)}
                { sucursal == 0 && (<div><br/>-Debes seleccionar una sucursal</div>)} 
                { (!isUpdate && archivo.length == 0) && (<div><br/>-Debes agregar un banner</div>)}
                { (isUpdate && archivo.length == 0 && img == '') && (<div><br/>-Debes agregar un banner</div>)}
                { !datos.tipo_banner && (<div><br/>-Debes seleccionar el tipo de banner</div>)}
                { requiresOrderSelection && !datos.orden_banner && (<div><br/>-Debes seleccionar el orden para Nivel 1</div>)}
                { es_ruta && !ruta_valida && (<div><br/>-Debes agregar una ruta valida</div>)} 
            </div>

            toast.warn(mensaje_texto, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    const persistBanner = async ({ payload, isUpdate, forceReplace }) => {
        setLook(true)
        const endpoint = isUpdate ? '/p_banners' : '/n_banner'
        const method = isUpdate ? 'PUT' : 'POST'
        const formData = new FormData()
        const payloadToSend = {
            ...payload,
            id_sucursal: payload.id_sucursal || payload.sucursal || 0,
            sucursal: payload.sucursal || payload.id_sucursal || 0,
            force_replace: forceReplace ? 1 : 0
        }
        if (isUpdate && ID) {
            payloadToSend.ID = ID
        }
        Object.entries(payloadToSend).forEach(([key, value]) => {
            if (value === undefined || value === null) return
            const normalizedValue = typeof value === 'boolean'
                ? (value ? '1' : '0')
                : value
            formData.append(key, normalizedValue)
        })
        if (archivo.length > 0 && archivo[0].file) {
            const fileToUpload = archivo[0].file
            formData.append('banner_image', fileToUpload, fileToUpload.name || 'banner.png')
        }
        try {
            const res = await fetch(endpoint, { method, body: formData })
            await res.json()
            props.setPag_actualizar(-1)
        } catch (err) {
            console.log('Error: '+err)
            setLook(false)
            throw err
        }
    }

    const agregarBanner =()=> handleBannerSubmit(false)

    const actualizarBanner =()=> handleBannerSubmit(true)

    const closeOrderModal = () => setOrderModal({ open: false, order: null, occupantName: '', payload: null, isUpdate: false })

    const confirmOrderReplacement = async () => {
        if (!orderModal.payload) {
            closeOrderModal()
            return
        }
        try {
            await persistBanner({ payload: orderModal.payload, isUpdate: orderModal.isUpdate, forceReplace: true })
            closeOrderModal()
        } catch (error) {
            console.error('No se pudo reemplazar el banner:', error)
            toast.error('No se pudo reemplazar el banner. Intenta de nuevo.')
        }
    }
    const eliminarBanner=()=>{
        setLook(true)
        fetch('/p_banners', { 
            method: 'DELETE', 
            body: JSON.stringify({ID}), 
            headers: {'Content-Type': 'application/json'} 
        })
        .then(res => res.json())
        .then(res => {
            if(res.RESULT==1){
                toast.warn(`Se ha eliminado correctamente.`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                props.setPag_actualizar(-1)
            }
            
        })
        .catch(err => console.log('Error: '+err))
    }

    const drop = () => <Dropzone
        onChangeStatus={changeDropzone}
        accept=".jpg,.JPG,.jpeg,.JPEG,.png,.PNG"
        maxFiles={1}
        maxSizeBytes={10485760}
        multiple={false}
        inputContent="Arrastre o toque para insertar un banner"
        inputWithFilesContent="Agregar archivos"
    />

    return (
        <Fragment>
            
            <button className="btn btn-outline-light-2x txt-dark mb-4 mt-4" onClick={()=> props.setPag_actualizar(-1)}>
                <i className="icofont icofont-arrow-left"/>Regresar
            </button>
            <div className='mt-3'>
                
                <h4 className='mt-3'>{ ID == 0 ? 'Agregar' : 'Actualizar'} Banner</h4>
                
                <FormularioBanner 
                    datos = {datos}
                    setDatos = {setDatos}
                />

                <div>

                    <p style={{
                        fontSize: "16px",
                        marginTop: "8px",
                        color: "#6c757d",
                        textAlign: "center",
                        marginBottom: "6px"
                    }}>
                        Formatos requeridos para el banner: <strong>.jpeg .jpg .png</strong>
                    </p>
                    {
                        ID == 0
                            ? drop()
                            : (
                                datos.img || datos.img_url
                                    ? (
                                        <div className="py-4 px-3" style={{background:'#DAE0FC', borderStyle:'dashed', borderColor:'#4466F2'}}>
                                            <div className="text-center">
                                                <img
                                                    src={datos.img_url || buildBannerImageUrl(datos.img) || buildRemoteSliderUrl(ID)}
                                                    alt="Banner actual"
                                                    style={{maxHeight: '220px', width: '100%', objectFit: 'contain'}}
                                                    onError={(e)=>{ e.target.onerror = null; e.target.src = DEFAULT_BANNER_IMAGE; }}
                                                />
                                                <p className="ml-3 h6 mt-3 d-flex justify-content-center align-items-center">
                                                    {datos.img || 'Banner actual'}
                                                    <i
                                                        className="fa fa-times text-right ml-2"
                                                        style={{cursor:'pointer', color:'#444548'}}
                                                        onClick={()=>{
                                                            setDatos(prev => {
                                                                releasePreviewUrl(prev.img_url);
                                                                return { ...prev, img:'', img_url:''};
                                                            });
                                                            setFiles([])
                                                        }}
                                                    ></i>
                                                </p>
                                            </div>
                                        </div>
                                    )
                                    : drop()
                            )
                    }

                    <p style={{
                        fontSize: "16px",
                        marginTop: "8px",
                        color: "#6c757d",
                        textAlign: "center"
                    }}>
                        Medidas recomendadas para {recommendedLabel}: <strong>{recommendedSize}</strong> <br></br>
                        Peso requerido: <strong>Maximo 3 Mb</strong>
                    </p>
                </div>

                <div className="col-md-12 mt-4 d-flex justify-content-between">
                    {
                        props.pag_actualizar !=0 && 
                        <div className="text-left">
                            <button className='btn btn-danger btn-lg ml-4' type="button" onClick={toggle2}>Borrar <i className="icon-trash" aria-hidden="true"></i></button>
                        </div>
                    }
                    <div className="text-right">
                        <Button className='btn-lg mr-4' disabled={look} onClick={()=>{ ID == 0 ? agregarBanner() : actualizarBanner()}}>Guardar</Button>
                    </div>
                </div>
            </div>

            <Modal isOpen={orderModal.open} toggle={closeOrderModal} className="modal-body" centered={true}>
                <ModalHeader toggle={closeOrderModal}>Confirmar reemplazo</ModalHeader>
                <ModalBody>
                    El orden {orderModal.order} ya lo ocupa {orderModal.occupantName || 'otro banner'}.? ¿Deseas reemplazarlo?
                </ModalBody>
                <ModalFooter>
                    <Button className="btn-danger" onClick={confirmOrderReplacement} disabled={look}><i className="icofont icofont-exchange" />Reemplazar</Button>
                    <Button color="secondary" onClick={closeOrderModal}>Cancelar</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modal2} toggle={toggle2} className="modal-body" centered={true}>
                <ModalHeader toggle={toggle2}>Eliminar</ModalHeader>
                <ModalBody>
                    ¿Está seguro que desea eliminar?
                </ModalBody>
                <ModalFooter>
                    <Button className="btn-danger" onClick={eliminarBanner} disabled={look}><i className="icofont icofont-trash" />Eliminar</Button>
                    <Button color="secondary" onClick={toggle2}>Cancelar</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}
 
export default Banners;
